var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loadError
    ? _c(
        "contentBox",
        { attrs: { loading: !_vm.recLoaded } },
        [
          _vm.zoning
            ? _c(
                "contentTitle",
                { attrs: { label: "ZONING", close: "home" } },
                [
                  _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.zoning.designation))]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.zoning
            ? _c(
                "contentBody",
                { attrs: { locked: _vm.token === null } },
                [
                  _vm.zoning
                    ? _c("contentActions", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            class: { active: _vm.shareShown === true },
                            on: { click: _vm.share }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "share zoning" }
                              },
                              [_vm._v("share")]
                            ),
                            _vm._v(" \n\t\t\t\tShare\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-light btn-sm",
                            on: { click: _vm.zoomTo }
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons md-18",
                                attrs: { title: "center map on zoning" }
                              },
                              [_vm._v("place")]
                            ),
                            _vm._v(" \n\t\t\t\tCenter\n\t\t\t")
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isAdmin
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-light btn-sm",
                                on: { click: _vm.edit }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons md-18",
                                    attrs: { title: "center map on overlay" }
                                  },
                                  [_vm._v("edit")]
                                ),
                                _vm._v(" \n\t\t\t\tEdit\n\t\t\t")
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shareShown
                    ? _c("share", {
                        attrs: { link: _vm.location },
                        on: { close: _vm.share }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-3" }, [
                    _vm.token === null
                      ? _c("div", { staticClass: "lock-block" }, [
                          _c(
                            "div",
                            {
                              staticClass: "row mx-0 hover-dk",
                              on: { click: _vm.routeLogin }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col-2 text-center my-auto" },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass:
                                        "material-icons text-light mr-3 md-36"
                                    },
                                    [_vm._v("account_box")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "py-3 col-10 pl-0 pr-3 py-3" },
                                [
                                  _c("h5", { staticClass: "mb-0 text-white" }, [
                                    _vm._v("Sign in to view")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    {
                                      staticClass:
                                        "mb-0 font-weight-light text-light"
                                    },
                                    [
                                      _vm._v(
                                        "Get details on density, size restrictions, and jurisdiction"
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "category-body" },
                      [
                        _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("DESCRIPTION")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "property-row" }, [
                            _c(
                              "div",
                              {
                                staticClass: "text-description property-locked"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.zoning.description ||
                                      "No description available"
                                  )
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "category" }, [
                          _c("div", { staticClass: "category-title" }, [
                            _vm._v("USE")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "property-row" }, [
                            _c("label", [_vm._v("Primary")]),
                            _vm._v(" "),
                            _vm.zoning.use.primary
                              ? _c(
                                  "span",
                                  { staticClass: "property-value-right" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.zoning.use.primary) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "undef property-value-right" },
                                  [_vm._v("\n\t\t\t\t\t\t\t-\n\t\t\t\t\t\t")]
                                )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "property-row" }, [
                            _c("label", [_vm._v("Secondary")]),
                            _vm._v(" "),
                            _vm.zoning.use.secondary
                              ? _c(
                                  "span",
                                  { staticClass: "property-value-right" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.zoning.use.secondary) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "undef property-value-right" },
                                  [_vm._v("\n\t\t\t\t\t\t\t-\n\t\t\t\t\t\t")]
                                )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.zoning.regulations, function(
                          regulation,
                          regInd
                        ) {
                          return _vm.zoning.regulations &&
                            _vm.zoning.regulations.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "pt-1 pb-0 clearfix position-relative"
                                },
                                [
                                  regulation.lotSize.minArea !== null ||
                                  regulation.lotSize.maxArea !== null ||
                                  regulation.lotSize.minWidth !== null ||
                                  regulation.lotSize.minWidthCorner !== null ||
                                  regulation.lotSize.minFrontage !== null ||
                                  regulation.lotSize.minDepth !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("LOT SIZE")]
                                        ),
                                        _vm._v(" "),
                                        regulation.lotSize.minArea !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Minimum area")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .minArea
                                                          )
                                                        ) +
                                                        " ft²\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotSize.maxArea !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Maximum area")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .maxArea
                                                          )
                                                        ) +
                                                        " ft²\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotSize.minWidth !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Minimum width")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .minWidth
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotSize.minWidthCorner !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Minimum width corner")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .minWidthCorner
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotSize.minFrontage !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Minimum frontage")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .minFrontage
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotSize.minDepth !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Minimum depth")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.lotSize
                                                              .minDepth
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  regulation.density.sfDu !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("DENSITY")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "property-row" },
                                          [
                                            _c("label", [_vm._v("SF/DU")]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "property-value-right property-locked"
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      _vm._f("integerLg")(
                                                        regulation.density.sfDu
                                                      )
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        regulation.density.sfDuNote !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("SF/DU note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.density
                                                            .sfDuNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  regulation.heightLimit.max !== null ||
                                  regulation.heightLimit
                                    .aboveEnclosedParking !== null ||
                                  regulation.heightLimit.roofFlat !== null ||
                                  regulation.heightLimit.roofPitched !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("HEIGHT LIMIT")]
                                        ),
                                        _vm._v(" "),
                                        regulation.heightLimit.max !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Height maximum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .heightLimit.max
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.heightLimit
                                          .aboveEnclosedParking !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    "Above enclosed parking"
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .heightLimit
                                                              .aboveEnclosedParking
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.heightLimit.roofFlat !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Roof flat limit")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .heightLimit
                                                              .roofFlat
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.heightLimit.roofPitched !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Roof pitched limit")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .heightLimit
                                                              .roofPitched
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.heightLimit.note !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Height note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.heightLimit
                                                            .note
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  regulation.far.base !== null ||
                                  regulation.far.min !== null ||
                                  regulation.far.max !== null ||
                                  regulation.far.residential !== null ||
                                  regulation.far.commercial !== null ||
                                  regulation.far.mixed !== null ||
                                  regulation.far.note !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("FLOOR TO AREA RATIO (FAR)")]
                                        ),
                                        _vm._v(" "),
                                        regulation.far.base !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR base")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far.base
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.min !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR minimum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far.min
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.max !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR maximum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far.max
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.residential !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR residential")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far
                                                            .residential
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.commercial !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR commercial")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far
                                                            .commercial
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.mixed !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR mixed")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far.mixed
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.far.note !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("FAR note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.far.note
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  regulation.setbacks.frontMin !== null ||
                                  regulation.setbacks.frontMax !== null ||
                                  regulation.setbacks.interiorSide !== null ||
                                  regulation.setbacks.streetSide !== null ||
                                  regulation.setbacks.rear !== null ||
                                  regulation.setbacks.rearAlley !== null ||
                                  regulation.setbacks.rearAlley !== null ||
                                  regulation.setbacks.generalNote !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("SETBACKS")]
                                        ),
                                        _vm._v(" "),
                                        regulation.setbacks.frontMin !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Front minimum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .frontMin
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.frontMinNote !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Front minimum note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .frontMinNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.frontMax !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Front maximum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .frontMax
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.frontMaxNote !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Front maximum note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .frontMaxNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.interiorSide !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Interior side")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .interiorSide
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.interiorSideNote !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Interior side note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .interiorSideNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.streetSide !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Street side")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .streetSide
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.streetSideNote !==
                                        null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Street side note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .streetSideNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.rear !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [_vm._v("Rear")]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .rear
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.rearAlley !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Rear Alley")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation.setbacks
                                                              .rearAlley
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.rearNote !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Rear note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .rearNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.setbacks.generalNote !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("General note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.setbacks
                                                            .generalNote
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  regulation.lotCoverage.min !== null ||
                                  regulation.lotCoverage.max !== null
                                    ? _c("div", { staticClass: "category" }, [
                                        _c(
                                          "div",
                                          { staticClass: "category-title" },
                                          [_vm._v("LOT COVERAGE")]
                                        ),
                                        _vm._v(" "),
                                        regulation.lotCoverage.min !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Lot coverage minimum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .lotCoverage.min
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotCoverage.max !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Lot coverage maximum")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm._f("integerLg")(
                                                            regulation
                                                              .lotCoverage.max
                                                          )
                                                        ) +
                                                        " ft\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        regulation.lotCoverage.note !== null
                                          ? _c(
                                              "div",
                                              { staticClass: "property-row" },
                                              [
                                                _c("label", [
                                                  _vm._v("Lot coverage note")
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "property-value-right property-locked"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          regulation.lotCoverage
                                                            .note
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t"
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e()
                                ]
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.zoning.jurisdiction !== null &&
                        _vm.zoning.jurisdiction.name !== null
                          ? _c("div", { staticClass: "category" }, [
                              _c("div", { staticClass: "category-title" }, [
                                _vm._v("JURISDICTION")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "property-row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-description property-locked"
                                  },
                                  [_vm._v(_vm._s(_vm.zoning.jurisdiction.name))]
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.zoning.references &&
                        _vm.zoning.references.length > 0
                          ? _c(
                              "div",
                              { staticClass: "category" },
                              [
                                _c("div", { staticClass: "category-title" }, [
                                  _vm._v("REFERENCES")
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.zoning.references, function(
                                  ref,
                                  idx
                                ) {
                                  return _c("div", [
                                    _c("div", { staticClass: "property-row" }, [
                                      _c("label", [
                                        _vm._v(_vm._s(ref.description))
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "float-right font-weight-bold"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: ref.url,
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c(
                                                "i",
                                                {
                                                  staticClass:
                                                    "material-icons md-12"
                                                },
                                                [_vm._v("open_in_new")]
                                              ),
                                              _vm._v(" Link")
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.token === null
                          ? _c(
                              "div",
                              {
                                staticClass: "over-action d-flex",
                                on: { click: _vm.routeLogin }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "over-action-box align-self-center text-white hover-dk"
                                  },
                                  [
                                    _c("div", { staticClass: "text-center" }, [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons text-light md-36"
                                        },
                                        [_vm._v("account_box")]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text-center" }, [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\tSign in to view\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29c12522", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c12522","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zoning/zoning.vue
// module id = null
// module chunks = 